/* eslint-disabled */
import ResponseGroup from "./ResponseGroup";
import Question from "./Question";
import ResponseExtend from "@/entity/extends/ResponseExtend";
import { helper } from "@/services/Helper";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Response extends ResponseExtend {
  public id!: number;

  public responseGroup?: ResponseGroup;
  public comment? = "";
  public value = undefined;
  public responseGroups: Array<ResponseGroup> = [];
  public question?: Question;
  public uuid = helper.generateId();
  public createdAt?: Date;
  public updatedAt?: Date;
  public createdFromIp? = "";
  public updatedFromIp? = "";

  constructor(object?: any) {
    super(object);
    if (object) {
      this.id = object.id;
      this.responseGroup =
        object.responseGroup instanceof ResponseGroup
          ? object.responseGroup
          : new ResponseGroup(object.responseGroup);
      this.comment = object.comment;
      this.value = object.value;
      hydrateCollection(object.responseGroups, ResponseGroup, this.responseGroups);
      this.question =
        object.question instanceof Question
          ? object.question
          : new Question(object.question);
      this.uuid = object.uuid;
      if (object.createdAt) {
        this.createdAt = new Date(object.createdAt);
      }
      if (object.updatedAt) {
        this.updatedAt = new Date(object.updatedAt);
      }
      this.createdFromIp = object.createdFromIp;
      this.updatedFromIp = object.updatedFromIp;
    }
  }
}
